<template>
  <v-container class="component_main">
    <router-view></router-view>
    <v-row v-show="showList" class="px-6">
      <v-col cols=12>
        <h1>Consulta de pagamentos</h1>
        <p>Gerencie as informações dos pagamentos</p>
      </v-col>
      <!-- <v-col class="d-flex justify-end">
        <v-btn 
          v-if="userData.PermissaoAcoes.faturamento.includes('addcronograma')"
          color="primary" 
          depressed
          height="30px"
          small 
          to="/faturamento/cronogramas/novocronograma"
        >Novo Cronograma</v-btn>
        <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            height="40px"
            class="px-2 ml-2"
            depressed
            v-bind="attrs"
            v-on="on"
            >Novo Cronograma</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip>
      </v-col> -->
      <v-col cols=12>
       <PagamentosConsultaFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :mesCorrente="mesCorrente"
          :filterList="(formData, page, clear) => getList(formData, page, clear)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :statusList="statusList"
          />
      </v-col>
    </v-row>
    <v-row wrap class="px-6">
      <v-col class="col-xs-12 col-sm-12 col-md-12 py-0 px-4">
        <PagamentosConsultaList
          v-show="showList"
          :list="list"
          :headers="headers"
          :pagination="pagination"
          :filterData="filterData"
          :getList="(filter, page) => getList(filter, page)"
          :getFile="() => downloadFile()"
          :statusList="statusList"
          :totais="totalConsulta"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PagamentosConsultaList from "@/components/recebiveis/pagamentos_consulta/List";
import PagamentosConsultaFilter from '@/components/recebiveis/pagamentos_consulta/Filter'

export default {
  components: {
    PagamentosConsultaList,
    PagamentosConsultaFilter
  },
  data() {
    return {
      list: [],
      controlResponsavel: true,
      showDados: false,
       headers: [
        { text: "Data do Pgto", value: "data_pagamento", align: "center", class:"pa-2", sortable: true },
        { text: "Operadora", value: "oper_nome", align: "left", class:"pa-2", sortable: true },
        { text: "Prestador", value: "prest_nome", align: "left", class:"pa-2", sortable: true },
        { text: "Vl.informado", value: "valor_informado", align: "right", class:"pa-1", sortable: true },
        { text: "Vl.liberado", value: "valor_liberado", align: "right", class:"pa-2", sortable: true },
        { text: "Vl.glosado", value: "valor_glosado", align: "right", class:"pa-2", sortable: true },
        { text: "Vl.lib. de recurso", value: "valor_pago_recurso", align: "right", class:"pa-2", width:"10%", sortable: true },
        { text: "Glosa mantida", value: "valor_glosa_mantida", align: "right", class:"pa-2", width:"10%", sortable: true },
        { text: "Vl.recursado", value: "valor_recursado", align: "right", class:"pa-2", width:"10%", sortable: true },
        { text: "Vl.acatado", value: "valor_acatado", align: "right", class:"pa-2", width:"10%", sortable: true },
        { text: "Estado", value: "etapa", align: "center", class:"pa-2", sortable: false },
      ],
      pagination: {
        limit: 10,
        offset: 1,
        total_pages: 0,
      },
      filterData: {},
      prestadores: [],
      showList: true,
      showPgto: false,
      statusList:[],
      mesCorrente: {
        data_entre: null,
        data_ate: null
      },
      totalConsulta: {
        valor_informado: 0,
        valor_liberado: 0,
        valor_glosado: 0,
        valor_recursado: 0,
        valor_pago_recurso: 0,
        valor_acatado: 0,
        valor_glosa_mantida: 0
      }
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeMount() {
    let opts = {
          grupoEconomico: this.grupoEconomico,
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "faturamento"
        }
    this.getOperadoras({ prestador_ids:[], modulo_operadora: "recebiveis"})
    this.getEtapasPagamento(opts)
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    getEtapasPagamento() {
      let payload = { grupo_economico: this.grupoEconomico}
      let obj = {query:[ {modulo: 'Recebiveis', acao: 'getetapaspagamento', payload}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(response => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader");
          return;
        }
        this.statusList = response.dados
      }) 
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    getList(filter, page, clear) {
      this.filterData = filter
      this.pagination.offset = page? page : 1
      if(clear){
        this.mesCorrente.data_entre = null
        this.mesCorrente.data_ate = null
        this.pagination.total_pages = 0
        this.pagination.offset = 1
        this.list = []
        return
      }
      let payload = filter != null 
        ? Object.assign({ grupo_economico: this.grupoEconomico, ...this.pagination, prestador_id:[], operadora_ans_id:[], ...filter }) 
        : Object.assign({ grupo_economico: this.grupoEconomico, prestador_id:[], operadora_ans_id:[],...this.pagination})
      let obj = {
        query: [{
          Modulo: "Recebiveis",
          Acao: "getconsultapagamentos",
          Payload: payload,
        }],
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        let { dados, total_pages, current_page, data_entre, data_ate, valor_informado, valor_liberado, valor_glosado, valor_pago_recurso, valor_recursado, valor_acatado, valor_glosa_mantida } = response
        this.mesCorrente.data_entre = data_entre.split('T')[0]
        this.mesCorrente.data_ate = data_ate.split('T')[0]
        this.pagination.total_pages = total_pages
        this.pagination.offset = current_page
        this.list = dados
        this.totalConsulta.valor_informado = valor_informado
        this.totalConsulta.valor_liberado = valor_liberado
        this.totalConsulta.valor_glosado = valor_glosado
        this.totalConsulta.valor_pago_recurso = valor_pago_recurso
        this.totalConsulta.valor_recursado = valor_recursado
        this.totalConsulta.valor_acatado = valor_acatado
        this.totalConsulta.valor_glosa_mantida = valor_glosa_mantida
      })
    },
    downloadFile() {
        let acao = "getcsvconsultapagamentos"
        let Payload = {grupo_economico: this.grupoEconomico, ...this.filterData}
        this.$store.dispatch("documents/getDocumentPost", { Payload, acao }, {root:true})
    },
  }
};
</script>
<style>
</style>